import React, { useEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
import WindowBrowser from "../components/browser-window";


import Scrollspy from 'react-scrollspy';

const LogMode = ({ months }) => {
    return (
        <div className="LogMode">
            {/* Only one WindowBrowser wrapping all months */}
            <WindowBrowser description={
                <>
                    {months.map((month) => {
                        const isMayTillAugust = ["May - START OF THE DRY LAB", "June", "July"].includes(month.month);

                        return (
                            <div key={month.month}>
                                <h1 className="monthName">{month.month}</h1>
                                <div>
                                    {month.weeks.map((week) => {
                                        return (
                                            <div key={week.title}>
                                                <p className="week">{week.title}</p>
                                                <div className="cells">
                                                    <div className="custom_cell">
                                                        <div className="left_cell">
                                                            <div className="border">
                                                                <b>Date</b>
                                                            </div>
                                                        </div>
                                                        <div className="right_cell">
                                                            <div className="border">
                                                                <b>Tasks</b>
                                                            </div>
                                                        </div>
                                                        {/* Render additional columns for August to October */}
                                                        {!isMayTillAugust && (
                                                            <>
                                                                <div className="right_cell">
                                                                    <div className="border">
                                                                        <b>Objectives</b>
                                                                    </div>
                                                                </div>
                                                                <div className="right_cell">
                                                                    <div className="border">
                                                                        <b>Methods</b>
                                                                    </div>
                                                                </div>
                                                                <div className="right_cell">
                                                                    <div className="border">
                                                                        <b>Results</b>
                                                                    </div>
                                                                </div>
                                                                <div className="right_cell">
                                                                    <div className="border">
                                                                        <b>Conclusions</b>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>

                                                    {week.tasks.map((task, idx) => {
                                                        return (
                                                            <div key={idx} className="custom_cell cell_date">
                                                                <div className="left_cell">
                                                                    <div className="border">
                                                                        {task.date}
                                                                    </div>
                                                                </div>
                                                                <div className="right_cell">
                                                                    <div className="border">
                                                                        {task.task}
                                                                    </div>
                                                                </div>
                                                                {/* Render additional columns for August to October */}
                                                                {!isMayTillAugust && (
                                                                    <>
                                                                        <div className="right_cell">
                                                                            <div className="border">
                                                                                {task.objective}
                                                                            </div>
                                                                        </div>
                                                                        <div className="right_cell">
                                                                            <div className="border">
                                                                                {task.method}
                                                                            </div>
                                                                        </div>
                                                                        <div className="right_cell">
                                                                            <div className="border">
                                                                                {task.result}
                                                                            </div>
                                                                        </div>
                                                                        <div className="right_cell">
                                                                            <div className="border">
                                                                                {task.conclusion}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </>
            } />
        </div>
    );
};



const CalendarMode = (months) => {
    return (
        <div>
            CalendarMode
        </div>
    )
}
const LabJournal = () => {

    const [mode, setMode] = useState("log")

    const months = [

        {
            month: "May - START OF THE DRY LAB",
            weeks: [
                {
                    title: "Week 1: 12-18 May 2024",
                    tasks: [
                        {
                            date: "13 May",
                            task: "Identifyng possible mutations."
                        },
                        {
                            date: "14 May",
                            task: "Modeling DNA 2nd structure prediction. "
                        },
                        {
                            date: "16 May",
                            task: "Modeling DNA 3rd structure prediction. "
                        },
                        {
                            date: "18 May",
                            task: "Preparation pdbqt files for autodock vina. "
                        }
                    ]
                },
                {
                    title: "Week 2: 19-25 May 2024",
                    tasks: [
                        {
                            date: "20 May",
                            task: "Submitting autodock vina tasks to a queue on the cluster."
                        }
                    ]
                },
                {
                    title: "Week 3: 26 May-1 June 2024",
                    tasks: [
                        {
                            date: "30 May",
                            task: "Writing script for parsing affinities from autodock vina, patchdock and hex outputs."
                        }
                    ]
                }
            ]
        },


        {
            month: "June",
            weeks: [
                {
                    title: "Week 4: 2-8 June 2024",
                    tasks: [
                        {
                            date: "3 Jun",
                            task: "Submiting tasks for patchdock."
                        },
                        {
                            date: "5 Jun",
                            task: "Analyzing patchdock outputs."
                        },
                        {
                            date: "6 Jun",
                            task: "Submiting hex task."
                        },
                        {
                            date: "8 Jun",
                            task: "Analyzing hex outputs."
                        }
                    ]
                },
                {
                    title: "Week 5: 9-15 June 2024",
                    tasks: [
                        {
                            date: "9 Jun",
                            task: "Preparation of mdp files. "
                        },
                        {
                            date: "11 Jun",
                            task: "Topology preparation and energy minimization."
                        },
                        {
                            date: "14 Jun",
                            task: "Heating up in nvt ensemble."
                        }
                    ]
                },
                {
                    title: "Week 6: 16-22 June 2024",
                    tasks: [
                        {
                            date: "19 Jun",
                            task: "NPT Equilibration."
                        }]
                }
            ]
        },
        {
            month: "July",
            weeks: [
                {
                    title: "Week 7: 30 June - 6 July 2024",
                    tasks: [
                        {
                            date: "5 Jul",
                            task: "MD production run."
                        }
                    ]
                },
                {
                    title: "Week 8: 21-27 July 2024",
                    tasks: [
                        {
                            date: "25 Jul",
                            task: "MM/PBSA analysis of the trajectories."
                        }
                    ]
                },
                {
                    title: "Week 9: 28 July - 3 August 2024",
                    tasks: [
                        {
                            date: "31 Jul",
                            task: "Statistical analysis and illustrations preparation."
                        },
                        {
                            date: "1 Aug",
                            task: "Ordering aptamers for MST and ELONA analyzes."
                        }
                    ]
                }
            ]
        },
        {
            month: "August - START OF THE WET LAB",
            weeks: [
                {
                    title: "ELONA",
                    tasks: [
                        {
                            date: "16 Aug",
                            task: "Protocol Optimization (Blocking Time)",
                            objective: "To optimize the blocking time for ELONA to reduce non-specific binding.",
                            method: "Compare 1-hour and 2-hour blocking times using 5% BSA in PBS. Bevacizumab concentration: 5 μg/ml. Read absorbance at 450 nm.",
                            result: "2-hour blocking reduced non-specific binding by 20% compared to 1-hour.",
                            conclusion: "2-hour blocking is optimal for reducing non-specific binding while maintaining strong signal detection."
                        },
                        {
                            date: "18 Aug",
                            task: "Protocol Optimization (Washing Steps)",
                            objective: "To determine the optimal number of washing steps to reduce background noise.",
                            method: "Compare three and five washing steps with PBST. Bevacizumab concentration: 1 μg/ml. Read absorbance at 450 nm.",
                            result: "Five washing steps reduced background noise while maintaining consistent signal strength.",
                            conclusion: "Five washing steps are optimal for the protocol, reducing noise without affecting signal quality."
                        },
                        {
                            date: "20 Aug",
                            task: "Calibration Curve (High Concentrations)",
                            objective: "To create a calibration curve for high concentrations of Bevacizumab.",
                            method: "Bevacizumab concentrations: 50 μg/ml, 25 μg/ml, 10 μg/ml, 5 μg/ml, 2.5 μg/ml, 1 μg/ml, 0.5 μg/ml. Read absorbance at 450 nm.",
                            result: "A linear response was observed from 0.5 μg/ml to 50 μg/ml. Plateau occurred after 50 μg/ml.",
                            conclusion: "The reliable detection range lies between 0.5 μg/ml and 50 μg/ml. Higher concentrations are suspected to lead to saturation."
                        },
                        {
                            date: "22 Aug",
                            task: "Calibration Curve (Low Concentrations)",
                            objective: "To test assay sensitivity at low concentrations of Bevacizumab.",
                            method: "Bevacizumab concentrations: 0.5 μg/ml, 1 μg/ml, 2.5 μg/ml, 5 μg/ml, 10 μg/ml, 25 μg/ml, 50 μg/ml. Read absorbance at 450 nm.",
                            result: "A linear relationship was observed up to 50 μg/ml, with no significant increase beyond this point.",
                            conclusion: "The assay shows reliable linearity up to 50 μg/ml; higher concentrations do not improve the signal."
                        },
                        {
                            date: "24 Aug",
                            task: "A14#1 Aptamer (Low Concentration Performance Proof of Concept)",
                            objective: "To evaluate the proof of concept for A14#1 aptamer sensitivity at low concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "A14#1 showed weak signals at concentrations below 0.1 μg/ml. The signal increased at 1 μg/ml and above, but with larger error margins.",
                            conclusion: "A14#1 shows limited sensitivity at lower concentrations and is better suited for detecting Bevacizumab at higher levels (≥1 μg/ml). The selected concentration range is analyzable, but improvements are needed for lower concentrations."
                        },
                        {
                            date: "26 Aug",
                            task: "A14#1 Aptamer (Repetition 1)",
                            objective: "To repeat and validate A14#1's performance at various concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "A14#1 performed consistently at concentrations ≥1 μg/ml, with limited detection at lower concentrations.",
                            conclusion: "This repetition confirmed the initial results. A14#1 is reliable for high concentration detection, but performance at lower concentrations remains suboptimal."
                        },
                        {
                            date: "28 Aug",
                            task: "A14#1 Aptamer (Repetition 2)",
                            objective: "To repeat and further validate A14#1’s performance across concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "Similar performance as in prior experiments, with strong signal at 1 μg/ml and above.",
                            conclusion: "Consistency of results across repetitions shows reliability of A14#1 for higher concentration detection."
                        },
                        {
                            date: "30 Aug",
                            task: "A14#1 Aptamer (Repetition 3)",
                            objective: "To ensure reproducibility of A14#1 across all tested concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "Consistent signal observed at concentrations above 1 μg/ml, with weaker response at lower concentrations.",
                            conclusion: "The repetition confirms that A14#1 aptamer is more suited to detect higher concentrations of Bevacizumab."
                        }
                    ]
                },
                {
                    title: "MST",
                    tasks: [
                        {
                            date: "19 Aug",
                            task: "Calibration (pH and concentration conditions)",
                            objective: "To determine the optimal pH, aptamer concentration, and Bevacizumab concentrations for MST analysis.",
                            method: "Serial dilution of Bevacizumab from 5000 nM to 0.153 nM in Tris-HCl buffer (pH 6.3). 50 nM of FAM-labeled aptamer used in the reaction.",
                            result: "MST conditions optimized for subsequent experiments. pH 6.3 selected to mimic clinical conditions of Bevacizumab.",
                            conclusion: "Calibration successful; selected conditions (pH 6.3 and aptamer concentration of 50 nM) provide reliable measurements."
                        },
                        {
                            date: "26 Aug",
                            task: "First MST result for A14#1",
                            objective: "To determine the binding affinity of Bevacizumab to aptamer A14#1 via MST.",
                            method: "Bevacizumab concentrations: 5000 nM to 0.153 nM, mixed with 50 nM FAM-labeled A14#1 aptamer.",
                            result: "Dissociation constant (Kd) for A14#1 determined to be 11.8 nM.",
                            conclusion: "The initial result for A14#1 shows a Kd value consistent with literature. Further repetitions needed for statistical validation."
                        },
                        {
                            date: "28 Aug",
                            task: "Second MST result for A14#1",
                            objective: "To repeat the MST experiment for aptamer A14#1 and validate the Kd result.",
                            method: "Same conditions as the first experiment, with Bevacizumab and A14#1 aptamer concentrations.",
                            result: "Kd value of 7.0 nM was obtained.",
                            conclusion: "Results are consistent with the first experiment, supporting a strong binding affinity for A14#1."
                        },
                        {
                            date: "29 Aug",
                            task: "Third MST result for A14#1",
                            objective: "To conduct a third trial for A14#1 to ensure reproducibility of results.",
                            method: "Same protocol as previous experiments with the same concentration ranges for Bevacizumab and A14#1 aptamer.",
                            result: "The final Kd result for A14#1 was determined to be 14.3 (11.0 ± 3.7 nM - average from three experiments).",
                            conclusion: "The final average Kd of 11.0 nM for A14#1 confirms the aptamer’s moderate binding affinity to Bevacizumab under pH 6.3."
                        }
                    ]
                }
            ]
        },
        {
            month: "September",
            weeks: [
                {
                    title: "ELONA",
                    tasks: [
                        {
                            date: "2 Sep",
                            task: "CU2#19 Aptamer (Low Concentration Performance Proof of Concept)",
                            objective: "To assess the proof of concept for CU2#19 aptamer sensitivity at low concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "CU2#19 demonstrated strong and consistent signals down to 0.01 μg/ml, with minimal errors.",
                            conclusion: "The CU2#19 aptamer demonstrated superior sensitivity compared to A14#1, especially at low concentrations, indicating successful optimization. The selected concentration range is suitable for further analysis."
                        },
                        {
                            date: "4 Sep",
                            task: "CU2#19 Aptamer (Repetition 1)",
                            objective: "To repeat and validate CU2#19's performance at various concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "CU2#19 consistently performed well across all tested concentrations, showing better sensitivity at low levels than A14#1.",
                            conclusion: "This repetition confirms the improved binding affinity of CU2#19, showing that it is effective at detecting Bevacizumab even at low concentrations, with high reproducibility."
                        },
                        {
                            date: "6 Sep",
                            task: "CU2#19 Aptamer (Repetition 2)",
                            objective: "To ensure reproducibility and validate CU2#19 performance.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "CU2#19 demonstrated consistent performance across all concentrations, especially at low levels.",
                            conclusion: "This experiment confirms the high reproducibility of CU2#19, proving it to be a reliable aptamer for Bevacizumab detection."
                        },
                        {
                            date: "10 Sept",
                            task: "CU2#19 Aptamer (Repetition 3)",
                            objective: "To ensure final validation and reproducibility for CU2#19 across concentrations.",
                            method: "Bevacizumab concentrations: 5 μg/ml, 1 μg/ml, 0.5 μg/ml, 0.1 μg/ml, 0.05 μg/ml, 0.01 μg/ml, 0.005 μg/ml, and control. Each concentration repeated 3 times. Read absorbance at 450 nm.",
                            result: "CU2#19 continued to perform with high sensitivity and precision across all concentration levels.",
                            conclusion: "CU2#19 has proven to be highly reliable and effective for detecting Bevacizumab at both low and high concentrations, confirming the success of the optimization process."
                        }
                    ]
                },
                {
                    title: "MST",
                    tasks: [
                        {
                            date: "2 Sep",
                            task: "First MST result for CU2#19",
                            objective: "To determine the binding affinity of optimized CU2#19 aptamer to Bevacizumab.",
                            method: "Same serial dilution of Bevacizumab mixed with 50 nM FAM-labeled CU2#19 aptamer.",
                            result: "Kd value for CU2#19 was determined to be 8.8 nM, showing improved affinity compared to A14#1.",
                            conclusion: "CU2#19 demonstrates significantly better binding affinity than A14#1 in initial experiments. Further repetition needed for confirmation."
                        },
                        {
                            date: "4 Sep",
                            task: "Second MST result for CU2#19",
                            objective: "To repeat and validate the Kd result for CU2#19 aptamer.",
                            method: "Same protocol and concentration range as the first CU2#19 experiment.",
                            result: "Kd value of 11.8 nM obtained for CU2#19, consistent with initial results.",
                            conclusion: "Repeated results validate the improved binding affinity of CU2#19."
                        },
                        {
                            date: "7 Sep",
                            task: "Third MST result for CU2#19",
                            objective: "Final repetition for CU2#19 to confirm reproducibility and reliability of the binding affinity.",
                            method: "Same protocol as previous experiments with CU2#19.",
                            result: "The final average Kd value for CU2#19 was determined 10.6 (10.4 ± 1.5 nM - average from three experiments).",
                            conclusion: "CU2#19 exhibits a consistently improved binding affinity compared to A14#1, with a Kd of 10.4 nM, confirming its enhanced suitability for Bevacizumab detection."
                        }
                    ]
                },
                {
                    title: "LFA",
                    tasks: [
                        {
                            date: "7 Sep",
                            task: "Ordering aptamers for LFA",
                            objective: "To order additional aptamers for LFA (Lateral Flow Assay) experiments.",
                            method: "Preparation for subsequent testing in lateral flow formats.",
                            result: "Aptamers ordered.",
                            conclusion: "Preparations complete for upcoming LFA experiments."
                        },
                        {
                            date: "21 Sep",
                            task: "LFA Test Strip Assembly: Optimization of Aptamer Concentration",
                            objective: "To determine the optimal amount of aptamer CU2#19 for each test strip to achieve reliable detection.",
                            method: "Assemble LFA strips using varying concentrations of aptamer CU2#19 (0.5, 5, 10, 20 ng). Apply Bevacizumab at 5 μg/ml and observe the color intensity of the test line.",
                            result: "Aptamer concentrations between 5 and 20 ng produced a distinct and clear signal, with 0.5 ng showing a weaker color intensity.",
                            conclusion: "A working range of 5 to 20 ng is optimal for CU2#19, providing sufficient sensitivity while reducing non-specific binding."
                        },
                        {
                            date: "25 Sep",
                            task: "LFA Test Strip Testing: Signal Consistency Evaluation",
                            objective: "To evaluate the consistency of signal across multiple test strips assembled with the same aptamer concentration.",
                            method: "Assemble LFA strips with 10 ng of aptamer CU2#19. Test using Bevacizumab concentrations of 1, 5, and 10 μg/ml. Visually assess the color intensity of the test line across 5 strips for each concentration.",
                            result: "Consistent color intensity was observed across all strips, with minor variability in the shade of red (<10%).",
                            conclusion: "Aptamer CU2#19 at 10 ng concentration provides consistent and reproducible color-based results across multiple test strips."
                        },
                        {
                            date: "30 Sep",
                            task: "LFA Test Strip Testing: Sensitivity Optimization",
                            objective: "To optimize the sensitivity of the LFA strip for low concentrations of Bevacizumab.",
                            method: "Assemble LFA strips with 10 ng of aptamer CU2#19. Test using Bevacizumab concentrations ranging from 0.1 to 5 μg/ml. Observe and visually assess the color intensity of the test line.",
                            result: "The LFA strip was able to produce a visible color signal for Bevacizumab concentrations as low as 0.5 μg/ml, with a gradual decrease in color intensity as concentrations decreased.",
                            conclusion: "Aptamer CU2#19 at 10 ng allows detection of low concentrations of Bevacizumab, with an effective lower limit of 0.5 μg/ml."
                        }
                    ]
                }
            ]
        }
    ]

    return (
        <div className="simple_page">
            <div className="mainIntro">
                <h1>Lab Journal</h1>
                <h3>Spot the Fake. Safeguard the Cure.</h3>
            </div>
            <section className="">
                <div className="calend">
                    <div>
                        <div className="mode_buttons " style={{ display: 'none' }}>
                            <a href="#" className="what_button active">
                                Laboratory work log
                            </a>
                            <a href="#" className="dark_button">
                                Calendar mode
                            </a>
                        </div>
                        <div className="modes">
                            {
                                mode == "log" ?
                                    <LogMode months={months} /> :
                                    <CalendarMode months={months} />
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}


export default LabJournal;
